import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT } from '../../constants';

// For ImageSlider, TestimonialSlider and Image components
export const getWidthByScreenSize = () => {
    const screenSize = window.innerWidth;

    if (screenSize < MOBILE_BREAKPOINT) {
        return 375;
    } else if (screenSize < TABLET_BREAKPOINT) {
        return 768;
    } else {
        return 1024;
    }
};
